import {
  SET_USER_FINAL_RESULT,
  SET_RESULT_ID,
  SET_PRIMARY_SKILL_RELEVANCE,
  SET_RESULT_PAGE_SECTIONS,
  SET_RESULT_PAGE_CAROUSEL,
  SET_RESUME_CAROUSEL,
  SET_USER_PUBLIC_RESULT,
} from "../action/result";
import { SET_USER_PREVIOUS_RESULT } from "../action/setPreviousResult";

const initialState = {}; // Define initial state

export default function ResultReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PRIMARY_SKILL_RELEVANCE: {
      const { payload } = action;
      return {
        ...state,
        skill_relevance: payload,
      };
    }
    case SET_USER_FINAL_RESULT: {
      const { payload } = action;
      return {
        ...state,
        result: payload,
      };
    }
    case SET_USER_PREVIOUS_RESULT: {
      const { payload } = action;
      return {
        ...state,
        previousResult: payload,
      };
    }
    case SET_RESULT_ID: {
      const { payload } = action;
      return {
        ...state,
        resultId: payload,
      };
    }
    case SET_RESULT_PAGE_SECTIONS: {
      const { payload } = action;
      return {
        ...state,
        resultPageSections: payload,
      };
    }
    case SET_RESUME_CAROUSEL: {
      const { payload } = action;
      return {
        ...state,
        resumeCarousel: payload,
      };
    }
    case SET_RESULT_PAGE_CAROUSEL: {
      const { payload } = action;
      return {
        ...state,
        resultPageCarousel: payload,
      };
    }
    case SET_USER_PUBLIC_RESULT: {
      const { payload } = action;
      return {
        ...state,
        publicResult: payload,
      };
    }
    default:
      return state;
  }
}
